export default __webpack_public_path__ + "static/media/Homepage-Social-Post-Showcase-LINKEDIN.c9f00e33.png";